<template>
  <div class="vc-w-100 vc-home-info-table">
    <!-- <v-row
      v-if="!currentPlace.forwarding"
      class="vc-w-100 ma-0 vc-flex-center mb-3"
    >
      <img height="48px" src="@/assets/img/white-logo-venx.png" alt="" />
    </v-row> -->
    <v-row class="vc-w-100 ma-0 mb-3">
      <v-col>
        <small class="vc-flex-center vc-text-bold pa-0 white--text"
          >Senhas com prioridade</small
        >
      </v-col>
      <v-col
        style="font-size: 25px;"
        cols="12"
        class="vc-flex-center vc-text-bold pa-0 white--text"
      >
        {{ lastCallText }}
      </v-col>
    </v-row>
    <hr class="mb-5" />
    <v-row class="vc-w-100 vc-flex-center ma-0">
      <v-col cols="6" class="vc-flex-center pa-0">
        <v-tooltip top color="primaryDark">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              rounded
              :disabled="peoplePreferential.length === 0"
              color="primary"
              class="white--text"
              @click="callClient"
            >
              <div class="vc-text-button">próximo</div>
              <v-icon size="20" right color="white">
                mdi-arrow-right-thick
              </v-icon>
            </v-btn>
          </template>
          <span>
            Chamar o(a) <strong>próximo(a)</strong> pessoa da lista.
          </span>
        </v-tooltip>
      </v-col>

      <v-col cols="6" class="vc-flex-center pa-0">
        <v-tooltip top color="primaryDark">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :disabled="!lastCall"
              rounded
              v-on="on"
              v-bind="attrs"
              color="primary"
              class=" white--text"
              @click="repeatPerson"
            >
              <div class="vc-text-button">repetir</div>
              <v-icon size="20" right color="white">
                mdi-repeat
              </v-icon>
            </v-btn>
          </template>
          <span v-if="lastCall">
            Chamar
            <strong>{{
              lastCall.name
                ? `${lastCall.name}`
                : `${lastCall.type_key}${lastCall.key}`
            }}</strong>
            novamente.
          </span>
        </v-tooltip>
      </v-col>
    </v-row>

    <v-row class="vc-w-100 table ma-0">
      <v-col cols="12" class="mt-5 pa-0">
        <v-row v-if="peoplePreferential.length > 0" class="vc-w-100 ma-0">
          <v-col cols="1" class="pa-0 "
            ><div class="white--text vc-text-bold text-center"></div
          ></v-col>
          <v-col cols="6" class="pa-0"
            ><div class="white--text vc-text-bold text-center">NOME</div></v-col
          >
          <v-col cols="1.5" class="pa-0"
            ><div class="white--text vc-text-bold text-center">OBS</div></v-col
          >
          <v-col cols="1.5" class="pa-0"
            ><div class="white--text vc-text-bold text-center">HORA</div></v-col
          >
          <v-col cols="2" class="pa-0"
            ><div class="white--text vc-text-bold text-center">
              SENHA
            </div></v-col
          >
        </v-row>
      </v-col>

      <v-col style="position: relative;" cols="12" class="pa-0">
        <div class="vc-w-100 vc-people-table-content smooth-croll">
          <v-row
            v-for="(person, i) in peoplePreferential"
            :key="`${i}${person.name}`"
            class="vc-w-100 table ma-0 mt-1 mb-1 text-center"
            :id="`${i}${peoplePreferential.length}`"
          >
            <div class="vc-flex-center ml-1">
              <v-btn
                width="20"
                height="20"
                class="mx-2"
                fab
                dark
                color="primaryLight"
                @click="
                  callClientSpecific(
                    person.key,
                    person.type_key,
                    person.name ? person.name : null,
                    person._id
                  )
                "
              >
                <v-icon x-small color="primaryDark">
                  mdi-account-voice
                </v-icon>
              </v-btn>
            </div>
            <v-col
              cols="6"
              class="table-row vc-flex-center vc-text-bold primaryDark--text pa-0"
              >{{ person.name || '-' }}</v-col
            >
            <v-col
              cols="1.5"
              class="table-row vc-flex-center vc-text-bold primaryDark--text ml-1  pa-0"
            >
              <v-tooltip
                bottom
                :color="person && person.observation ? '' : 'primary'"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-on="on"
                    v-bind="attrs"
                    @click="editPerson(person)"
                  >
                    <v-icon>mdi-pencil-box</v-icon>
                  </v-btn>
                </template>
                <span>{{
                  person && person.observation
                    ? 'Paciente com observações'
                    : 'Paciente sem obsevação'
                }}</span>
              </v-tooltip></v-col
            >
            <v-col
              cols="2.5"
              class="table-row vc-flex-center vc-text-bold primaryDark--text ml-1 mr-1 pa-0"
              >{{ person.ticketHour }}</v-col
            >
            <v-col
              cols="2.5"
              class="table-row vc-flex-center vc-text-bold primaryDark--text pa-0"
              >{{
                person.key && person.type_key
                  ? `${person.type_key}${person.key}`
                  : '-'
              }}</v-col
            >
          </v-row>
        </div>
        <!-- <a
          id="goMoveButton"
          style="position: absolute; bottom: 10px; right: 10px;"
          class="vc-w-100 text-end"
          v-if="peoplePreferential.length > 6 && !goTopCheck"
          @click="goMoveTable"
        >
          <v-btn width="30" height="30" class="mx-2" fab dark color="primaryDark">
            <v-icon small dark>
              mdi-arrow-down-thick
            </v-icon>
          </v-btn>
        </a>

        <a
          id="goMoveButton"
          style="position: absolute; bottom: 10px; right: 10px;"
          class="vc-w-100 text-end"
          v-else-if="peoplePreferential.length > 6 && goTopCheck"
          @click="goTop"
        >
          <v-btn width="30" height="30" class="mx-2" fab dark color="primaryDark">
            <v-icon small dark>
              mdi-arrow-up-thick
            </v-icon>
          </v-btn>
        </a> -->
        <!-- <div
          v-if="peoplePreferential.length >= 1 && currentPlace.type === 'KEYALL'"
          class="vc-flex-center ml-1 mt-10"
        >
          <v-dialog transition="dialog-bottom-transition" max-width="600">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="error" v-bind="attrs" v-on="on">Zerar Fila</v-btn>
            </template>
            <template v-slot:default="dialog">
              <v-card>
                <v-toolbar color="primary" dark>Zerar Fila</v-toolbar>
                <v-card-text>
                  <div class="mt-10">
                    <v-alert elevation="13" outlined prominent type="warning"
                      >Aviso esta ação irá remover as fichas de todas as salas,
                      tem certeza que quer prosseguir?</v-alert
                    >
                  </div>
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn color="primary" @click="deleteQueue">Confirmar</v-btn>
                  <v-btn color="error" @click="dialog.value = false"
                    >Cancelar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </div> -->
        <v-row
          v-if="peoplePreferential.length === 0"
          class="vc-w-100 table ma-0 mt-1 mb-1 text-center"
        >
          <v-col
            style="border-radius: 3px;"
            cols="12"
            class="table-row vc-flex-center primaryDark--text pa-4"
          >
            <v-alert
              dense
              border="left"
              type="info"
              color="primary"
              class="mb-0 alert-text"
            >
              Não existe nenhum cliente a <strong>espera</strong> no momento.
            </v-alert>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogEdit" max-width="600">
      <v-card>
        <v-card-title>
          <span class="text-h5"
            >Observações de
            {{
              personToEdit && personToEdit.name
                ? personToEdit.name
                : personToEdit.type_key + personToEdit.key
            }}</span
          >
        </v-card-title>
        <v-card-text>
          <v-textarea v-model="personToEdit.observation" rows="2" auto-grow />
          <!-- Adicione outros campos conforme necessário -->
        </v-card-text>
        <v-card-actions>
          <v-btn color="secondary" @click="dialogEdit = false">Cancelar</v-btn>
          <v-btn color="primary" @click="savePerson">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { eventBus } from '@/main';
export default {
  name: 'vc-home-info-table-preferential',
  props: {
    currentPlace: { type: Object, default: () => {} },
    lastPerson: { type: Object, default: () => {} },
  },
  data() {
    return {
      repeating: false,
      goTopCheck: false,
      goMove: 0,
      dialogEdit: false,
      personToEdit: {},
      peoplePreferential: [],
      lastCall: null,
      lastCallDisabled: null,
    };
  },
  computed: {
    ...mapGetters(['people']),
    lastCallText() {
      if (this.lastCall == null) {
        return this.repeating
          ? `Chamando senha novamente: `
          : `Última senha chamada: `;
      } else {
        return this.repeating
          ? `Chamando senha novamente: ${this.lastCall.type_key}${this.lastCall.key}`
          : `Última senha chamada: ${this.lastCall.type_key}${this.lastCall.key}`;
      }
    },
  },
  mounted() {
    console.log('não to aqui');
    this.populatePreferentialPeople();
    eventBus.$on('cleanLastCallPreferential', (data) => {
      console.log(data);
      this.lastCallDisabled = data;
    });
  },
  watch: {
    people() {
      this.populatePreferentialPeople();
    },
    currentPlace() {
      this.lastCall = null;
    },
    lastCallDisabled() {
      this.lastCall = null;
    },
  },
  methods: {
    editPerson(person) {
      this.personToEdit = { ...person };
      this.dialogEdit = true;
    },
    savePerson() {
      console.log('Salvando a pessoa editada:', this.personToEdit);
      let body = {
        people_id: this.personToEdit._id,
        observation: this.personToEdit.observation,
      };
      this.$store
        .dispatch('patchClient', body)
        .then(() => {
          this.dialogEdit = false;
          this.$notify({
            group: 'foo',
            type: 'success',
            title: 'Sucesso!',
            text: 'Observação editada com sucesso!',
          });
          setTimeout(() => {
            location.reload();
          }, 500);
        })
        .catch((error) => {
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Erro!',
            text: `Ocorreu um erro ao salvar a pessoa: ${error}`,
          });
        });
    },
    populatePreferentialPeople() {
      const auxArray = [];
      if (this.peoplePreferential) {
        this.people.map((item) => {
          let newTypeKey = item.type_key[0] === 'P';
          if (newTypeKey) {
            auxArray.push(item);
          }
        });
        this.peoplePreferential = auxArray;
      } else {
        this.peoplePreferential = [];
      }
    },
    deleteQueue() {
      this.$store.dispatch('deleteeQueue').then(() => {
        this.$store.commit('SET_PEOPLE', []);
        this.$notify({
          group: 'foo',
          title: 'Sucesso',
          text: 'Fila Zerada com sucesso',
          type: 'success',
        });
      });
    },
    callClient() {
      this.$store.commit('SET_ALL_QUEUES');
      const person = this.peoplePreferential[0];
      this.lastCall = person;
      if (this.repeating === true) this.repeating = false;

      this.$store
        .dispatch('callClient', {
          place_id: this.currentPlace._id,
          type: this.currentPlace.type,
          key: person.key,
          type_key: person.type_key,
          name: person.name ? person.name : null,
          _id: person._id,
        })
        .then((resp) => {
          this.lastCall = resp;
        });
      this.peoplePreferential.splice(0, 1);
    },
    callClientSpecific(key, typeKey, name, _id) {
      this.$store.commit('SET_ALL_QUEUES');
      if (this.repeating === true) this.repeating = false;

      this.$store
        .dispatch('callClient', {
          place_id: this.currentPlace._id,
          type: this.currentPlace.type,
          key: key,
          type_key: typeKey,
          name: name,
          _id: _id,
        })
        .then((resp) => {
          this.lastCall = resp;
        });
      const clientIndex = this.peoplePreferential.findIndex(
        (item) => item.key === key
      );
      this.peoplePreferential.splice(clientIndex, 1);
    },
    repeatPerson() {
      this.repeating = true;
      this.$socket.emit(`repeat_call`, this.lastCall);
    },
    goMoveTable() {
      let goMoveButton = document.getElementById('goMoveButton');
      if (this.goMove + 6 > this.people.length - 1) {
        this.goMove = this.people.length - 1;
        goMoveButton.href = `#${this.goMove}${this.people.length}`;
      } else {
        this.goMove = this.goMove + 6;
        goMoveButton.href = `#${this.goMove}${this.people.length}`;
      }
      if (this.goMove === this.people.length - 4) {
        this.goTopCheck = true;
      }
    },
    goTop() {
      let goMoveButton = document.getElementById('goMoveButton');
      this.goTopCheck = false;
      goMoveButton.href = `#0${this.people.length}`;
      this.goMove = 6;
    },
  },
};
</script>

<style scoped lang="scss">
.smooth-croll {
  scroll-behavior: smooth;
}
</style>
